export function getFilename(combo: number[]) {
  let filename = `${process.env.PUBLIC_URL}/configurator/assets/images/drawers/`;
  combo.sort((a, b) => b - a);
  for (const value of combo) {
    filename = `${filename}${value}_`;
  }
  filename = filename.slice(0, -1);
  return `${filename}.svg`;
}
